<template>
  <div
    class="h-full w-full"
    style="position: relative"
  >
    <mcs-btn
      color="white"
      class="ma-2"
      style="padding: 0 10px !important; min-width: inherit; right: 0; position: absolute; z-index: 1"
      @click="openDrawer"
    >
      <v-icon>mdi-arrow-expand-all</v-icon>
    </mcs-btn>
    <template v-if="!is_drawer_open">
      <mcs-3d-viewer
        style="display: block; width: 100%; height: 100%"
        :images.prop="images"
        :width.prop="width"
        :height.prop="height"
        :model-url="modelUrl"
        :sideNames.prop="sideNames"
        :environment-type="environmentType"
        :foldAnimation.prop="foldAnimation"
      ></mcs-3d-viewer>
    </template>
  </div>
</template>

<script>
import { DRAWERS } from '@/utils/constants';
import { mapGetters } from 'vuex';
export default {
  name: 'Mcs3dview',
  props: {
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
    images: { type: Array, default: () => [] },
    modelUrl: { type: String, default: '' },
    sideNames: { type: Array, default: () => [] },
    environmentType: { type: String, default: '' },
    // Builder product.json driving the 3D fold open/close animation
    // (null => viewer hides the toggle).
    foldAnimation: { type: String, default: null }
  },
  data() {
    return { drawerId: DRAWERS.THREE_D_DRAWER };
  },
  computed: {
    is_drawer_open() {
      return DRAWERS.PROJECT_THREED_DRAWER === this.top_drawer?.id;
    },
    ...mapGetters({ top_drawer: 'drawers/topDrawer' })
  },
  methods: {
    openDrawer() {
      this.$store.dispatch('drawers/open', {
        drawerId: DRAWERS.PROJECT_THREED_DRAWER,
        data: {
          width: this.width,
          height: this.height,
          images: this.images,
          modelUrl: this.modelUrl,
          sideNames: this.sideNames,
          environmentType: this.environmentType,
          foldAnimation: this.foldAnimation
        }
      });
    }
  }
};
</script>
